export default __webpack_public_path__ + "static/factory-c2eda2e2948770e34474bf45c1e4ced4.jpg";